module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "forgot grid h100"
  }, [_c('div', {}, [_c('h3', [_vm._v("Prego inserisci la tua nuova password")]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "formLogin",
    attrs: {
      "model": _vm.formel,
      "rules": _vm.rules,
      "status-icon": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.forgot('formLogin')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "placeholder": "Password",
      "prefix-icon": "fas fa-key",
      "name": "password"
    },
    model: {
      value: (_vm.formel.password),
      callback: function($$v) {
        _vm.$set(_vm.formel, "password", $$v)
      },
      expression: "formel.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn btn-blue block",
    on: {
      "click": function($event) {
        return _vm.forgot('formLogin')
      }
    }
  }, [_vm._v("cambia password")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a333d36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 651
// module chunks = 1